import { SearchMaskInputType } from '../../globalTypes';
function modifyUIValueConfirmed(searchMaskInput, inputValue) {
    switch (searchMaskInput.type) {
        case SearchMaskInputType.DESTINATION: {
            if (inputValue.uiValue === null) {
                searchMaskInput.confirmedValue.uiValue = inputValue.value.value;
            }
            return searchMaskInput;
        }
        case SearchMaskInputType.DEPARTURE_AIRPORT: {
            if (inputValue.uiValue === null) {
                searchMaskInput.confirmedValue.uiValue = inputValue.value.value;
            }
            return searchMaskInput;
        }
        default:
            return searchMaskInput;
    }
}
function modifySearchMaskInputConfirmed(searchMaskRequest, lturState) {
    if (typeof lturState.websiteState !== 'undefined') {
        var websiteState = lturState.websiteState;
        if (websiteState.searchMask.searchMaskBundle !== null) {
            var searchMaskBundle = websiteState.searchMask.searchMaskBundle;
            var searchMaskGroup = searchMaskBundle.groups[searchMaskRequest.searchMaskGroupType];
            if (searchMaskGroup !== null) {
                searchMaskGroup.inputs[searchMaskRequest.searchMaskInput.type].confirmedValue =
                    searchMaskRequest.inputValueParam;
                searchMaskGroup.inputs[searchMaskRequest.searchMaskInput.type].coreQuery =
                    searchMaskRequest.searchMaskInput.coreQuery;
                searchMaskGroup.inputs[searchMaskRequest.searchMaskInput.type].coreOptions =
                    searchMaskRequest.searchMaskInput.coreOptions;
                modifyUIValueConfirmed(searchMaskGroup.inputs[searchMaskRequest.searchMaskInput.type], searchMaskRequest.inputValueParam);
            }
        }
    }
    return lturState;
}
function modifySearchMaskInputDefault(searchMaskRequest, lturState) {
    if (typeof lturState.websiteState !== 'undefined') {
        var websiteState = lturState.websiteState;
        if (websiteState.searchMask.searchMaskBundle !== null) {
            var searchMaskBundle = websiteState.searchMask.searchMaskBundle;
            var searchMaskGroup = searchMaskBundle.groups[searchMaskRequest.searchMaskGroupType];
            if (searchMaskGroup !== null) {
                searchMaskGroup.inputs[searchMaskRequest.searchMaskInput.type].confirmedValue =
                    JSON.parse(JSON.stringify(searchMaskRequest.inputValueParam));
            }
        }
    }
    return lturState;
}
export function resetSearchMaskBundleToDefaultAction(searchMaskRequest, lturState) {
    return modifySearchMaskInputDefault(searchMaskRequest, lturState);
}
export function getSearchMaskBundleConfirmedAction(searchMaskRequest, lturState) {
    return modifySearchMaskInputConfirmed(searchMaskRequest, lturState);
}
export function initSearchMaskModalAction(searchMaskModalRequest, lturState) {
    if (typeof lturState.websiteState !== 'undefined') {
        var websiteState = lturState.websiteState;
        if (websiteState.searchMask.searchMaskBundle !== null) {
            var searchMaskBundle = websiteState.searchMask.searchMaskBundle;
            var searchMaskGroup = searchMaskBundle.groups[searchMaskModalRequest.searchMaskGroupType];
            if (searchMaskGroup !== null) {
                searchMaskGroup.inputs[searchMaskModalRequest.searchMaskInput.type].modalIsInitialized = true;
                var count_1 = 0;
                Object.values(searchMaskGroup.inputs).forEach(function (element) {
                    if (element.modalIsInitialized) {
                        count_1 += 1;
                    }
                });
                if (Object.values(searchMaskGroup.inputs).length === count_1) {
                    searchMaskGroup.initialized = true;
                }
            }
        }
    }
    return lturState;
}
